import jsPDF from "jspdf";
import { DateTime } from "luxon";
import fonts from "../../assets/fonts/fonts.js";
import images from "../../assets/oferta_images.js";
import router from "../../router/index.js";
import { replaceSpecialCh, formatPhoneNo, dimTextString, daysText } from '@/utils';


export const pdf_oferta_materie_prima = {
  createOfertaMateriePrimaPDF(oferta, pdfExtraInfo) {
    return new Promise(resolve => {
      try {
        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4"
        });

        const logo = images.data.logo
		// const vatRate = vatRateOnDate(oferta.data)
		const curs = oferta.moneda == "ron" ? 1 : oferta.curs;
		const moneda = oferta.moneda;
		const daysTxt = daysText(oferta.valid)

		const products_no_oferta = oferta.produse_obj.length + oferta.custom_obj.length

		const printProduct = (produs) => {
			let details = produs.detalii;

			if (details != undefined && details != "") {
				details = " - " + details;
			} else {
				details = "";
			}

			let dim = dimTextString(produs);
			if (dim == "") {
				dim = produs.dimensiune;
			}

			// For old offers that do not have 'denumire' in object format
			let denumire = "";
			if (produs.denumire.value) {
				denumire = `${produs.denumire.value} ${produs.material}${details}, ${dim}, aliaj: ${produs.aliaj}`;
			} else {
				denumire = `${produs.denumire} ${produs.material}${details}, ${produs.dimensiune}, aliaj: ${produs.aliaj}`;
			}

			let twoLine = false;

			if (denumire.length > 64) {
				if (produs.t_livrare) {
					denumire += " - Livrare: " + produs.t_livrare;
				}
				denumire = doc.splitTextToSize(denumire, 95);
				twoLine = true;
			}

			doc.text(String(produs.nr), 11, space);
			if (produs.modified) {
				doc.setTextColor(244, 67, 54);
			}
			doc.text(denumire, 18, space);
			doc.setTextColor(100);

			doc.text(produs.cantitate + " " + produs.um, 118, space);
			doc.text(produs.pret_u + " " + moneda, 136, space, {
				align: "left",
			});
			doc.text(produs.pret_kg + " " + moneda + "/kg", 160, space, {
				align: "left",
			});
			doc.text(produs.pret_t + " " + moneda, 200, space, {
				align: "right",
			});

			if (pdfExtraInfo) {
				let tl = 0;

				let pret_kg_lei = (produs.pret_kg * curs).toFixed(2);

				if (produs.um != "kg") {
					doc.text(produs.greutate + " kg", 118, space + 4);
					doc.text(pret_kg_lei + " ron", 136, space + 4);
					doc.text(
						(produs.greutate * pret_kg_lei).toFixed(2) + " ron",
						180,
						space + 4
					);
					tl = tl + 1;
				} else if (oferta.moneda == "eur") {
					doc.text(pret_kg_lei + " ron", 136, space + 4);
					doc.text(
						(produs.greutate * pret_kg_lei).toFixed(2) + " ron",
						180,
						space + 4
					);
					tl = tl + 1;
				}
				if (tl > 0) {
					twoLine = true;
				}
			}

			if (produs.t_livrare && !twoLine) {
				doc.text("- Livrare: " + produs.t_livrare, 18, space + 4);
				twoLine = true;
			}

			if (twoLine) {
				space = space + 3;
			}

		};

        //add the font to jsPDF
        doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
        doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
        doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
        doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

        // set font
        doc.setFont("Roboto", "normal");
        doc.setTextColor(100);

		
		// Draw grey header rectangle
		doc.setFillColor(242, 244, 248);
		doc.rect(0, 0, 210, 25, "F");

        // Add Logo
		doc.addImage(logo, "JPEG", 10, 9, 27, 12);

        // Top header text
        doc.setFontSize(8);
		doc.setTextColor(150);
		doc.text(["CUI/CIF: RO 35671874", "RegCom: J2016000468359"], 52, 14);
		doc.text(
			["Strada Caprioarei nr.11", "307200 Ghiroda, jud. Timis"],
			98,
			14
		);
		doc.text(["Email: office@cuprolli.ro", "Web: cuprolli.ro"], 147, 14);
		doc.setDrawColor(243, 153, 46);
		doc.setLineWidth(0.5);
		doc.line(0, 25, 210, 25);

		// Center Info
		doc.setFont("Roboto", "normal");
		const data = DateTime.fromISO(String(oferta.data)).toFormat('dd.MM.yyyy')
		doc.setFontSize(16);
		doc.setTextColor(243, 153, 46);
		doc.text('OFERTA', 105, 68, { align: 'center' });
		doc.setFontSize(9);
		doc.setTextColor(100);
		doc.text(`Nr: ${oferta.id} / ${data}`, 105, 74, { align: 'center' });

		// Header - Left side
		doc.setFont("Roboto", "bold");
		doc.text("Catre", 10, 35);
		doc.setFont("Roboto", "normal");
		const name = replaceSpecialCh(oferta.nume);
		const nameSplit = doc.splitTextToSize(name, 72);
		
		let drop = 40;
		doc.text(nameSplit, 10, drop);

		if (nameSplit.length == 1) {
			drop = drop + 5;
		} else {
			drop = drop + 9;
		}

		if (oferta.cui) {
			doc.text("CUI/CIF: " + oferta.cui, 10, drop);
			drop = drop + 4;
		}

		let address = replaceSpecialCh(oferta.adresa);
		if (oferta.oras) {
			address += ", " + replaceSpecialCh(oferta.oras);
		}
		const addressSplit = doc.splitTextToSize(address, 72);
		doc.text(addressSplit, 10, drop);
		
		if (address.length != 0 && address.length <= 44) {
			drop = drop + 4;
		} else if (address.length != 0 && address.length <= 73) {
			drop = drop + 8;
		} else if (address.length != 0) {
			drop = drop + 12;
		}

		drop = drop + 1;

		const details = [];
		if (oferta.persoana) {
			details.push("Dl/Dna: " + oferta.persoana);
		}
		if (oferta.email) {
			details.push("Email: " + oferta.email);
		}
		if (oferta.tel && oferta.tel != "-") {
			details.push("Tel: " + formatPhoneNo(oferta.tel));
		}
		doc.text(details, 10, drop, {
			lineHeightFactor: 1.4,
		});

		// Header - Right side
		doc.setFont("Roboto", "bold");
		doc.text("Intocmit de:", 147, 35);
		doc.setFont("Roboto", "normal");

		doc.text(
			[
				"Dl/Dna: " + oferta.username,
				"Email: " + oferta.email_user,
				"Tel: +4 " + oferta.tel_user,
			],
			147,
			40,
			{
				lineHeightFactor: 1.4,
			}
		);

		//
		// Products table print
		const PAGE_BREAK_THRESHOLD = 215;

		const printTableHeader = (y) => {
			doc.setFont("Roboto", "bold");
			doc.text("Nr.", 10, y);
			doc.text("Denumire produs", 18, y);
			doc.text("Cantitate", 118, y, { align: "left" });
			doc.text("Pret unitar", 136, y, { align: "left" });
			doc.text("Pret/kg", 160, y, { align: "left" });
			doc.text("Valoare", 198, y, { align: "right" });
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(10, y + 2, 200, y + 2);
			doc.setFont("Roboto", "normal");
		};

		// Table header
		printTableHeader(86);
		let space = 93;

		// Print products
		for (let i = 0; i < oferta.produse_obj.length; i++) {
			printProduct(oferta.produse_obj[i]);
			doc.setLineWidth(0.2);
			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;

			const hasMore = i < oferta.produse_obj.length - 1 || oferta.custom_obj.length > 0;
			if (hasMore && space > PAGE_BREAK_THRESHOLD) {
				doc.addPage();
				doc.setTextColor(100);
				space = 20;
				printTableHeader(space);
				space = space + 7;
			}
		}

		for (let i = 0; i < oferta.custom_obj.length; i++) {
			const produs = oferta.custom_obj[i];
			let details = produs.detalii;
			if (details != undefined && details != "") {
				details = " - " + details;
			} else {
				details = "";
			}

			let dimensiune_text = produs.dimensiune_text;
			if (dimensiune_text != undefined && dimensiune_text != "") {
				dimensiune_text = " - " + dimensiune_text;
			} else {
				dimensiune_text = "";
			}

			let customTwoLine = false

			doc.text(produs.nr.toString(), 11, space);
			let denumire = `${produs.denumire}${details} ${dimensiune_text}`;

			if (denumire.length > 60) {
				denumire = doc.splitTextToSize(denumire, 90);
				customTwoLine = true;
			}
			doc.text(denumire, 18, space);

			doc.text(produs.cantitate + " " + produs.um, 118, space);
			doc.text(produs.pret_u + " " + moneda, 136, space);
			doc.text("-", 164, space);
			doc.text(produs.pret_t + " " + moneda, 200, space, {
				align: "right",
			});

			if (customTwoLine) {
				space = space + 3;
			}

			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;

			if (i < oferta.custom_obj.length - 1 && space > PAGE_BREAK_THRESHOLD) {
				doc.addPage();
				doc.setTextColor(100);
				space = 20;
				printTableHeader(space);
				space = space + 7;
			}
		}

		if (oferta.debitare_obj != null && oferta.debitare_obj?.form) {
			doc.text(String(products_no_oferta + 1), 11, space);
			doc.setFont("Roboto", "bold");
			doc.text(oferta.debitare_obj.name, 18, space);
			doc.setFont("Roboto", "normal");
			doc.text(
				oferta.debitare_obj.cantitate + " " + oferta.debitare_obj.um,
				119,
				space
			);

			doc.text(oferta.debitare_obj.pret + " " + moneda, 136, space);
			doc.text("-", 164, space);
			doc.text(oferta.debitare_obj.val + " " + moneda, 200, space, {
				align: "right",
			});

			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;
		}

		if (oferta.transport_obj != null && oferta.transport_obj.form) {
			doc.text(
				String(
					oferta.debitare_obj?.form
						? products_no_oferta + 2
						: products_no_oferta + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text(oferta.transport_obj.name, 18, space);
			doc.setFont("Roboto", "normal");

			doc.text(
				oferta.transport_obj.cantitate + " " + oferta.transport_obj.um,
				122,
				space,
				{
					align: "left",
				}
			);
			doc.text(oferta.transport_obj.pret + " " + moneda, 136, space);
			doc.text("-", 164, space);
			doc.text(oferta.transport_obj.val + " " + moneda, 200, space, {
				align: "right",
			});

		} else if (oferta.transport_obj != null && oferta.transport_obj.included) {
			doc.text(
				String(
					oferta.debitare_obj?.form
						? products_no_oferta + 2
						: products_no_oferta + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text("Transport inclus", 18, space);

		} else {
			doc.text(
				String(
					oferta.debitare_obj?.form
						? products_no_oferta + 2
						: products_no_oferta + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text("Nu include transport", 18, space);
		}

		doc.line(10, space + 3, 200, space + 3);
		space = space + 8;

		doc.setFont("Roboto", "bold");

		doc.text("Total fara TVA", 153, space + 2);
		doc.text(
			oferta.val_fara_tva + " " + oferta.moneda,
			200,
			space + 2, { align: "right" }
		);
		doc.setFont("Roboto", "normal");
		doc.text("TVA", 168, space + 7);
		doc.text(
			oferta.val_tva + " " + oferta.moneda,
			200,
			space + 7, { align: "right" }
		);
		doc.setFont("Roboto", "bold");
		doc.text("TOTAL", 164, space + 12);
		doc.text(oferta.suma + " " + oferta.moneda, 200, space + 12, { align: "right" });
		doc.line(10, space + 16, 200, space + 16);

		// Products footer
		doc.setFont("Roboto", "normal");
		if (oferta.t_livrare) {
			doc.text("Conditii livrare: " + oferta.t_livrare, 10, space + 2);
			if (oferta.t_plata && oferta.valid) {
				doc.text("Conditii plata: " + oferta.t_plata, 10, space + 7);
				doc.text(
					"Valabilitate oferta: " + daysTxt,
					10,
					space + 12
				);
			} else if (oferta.t_plata) {
				doc.text("Conditii plata: " + oferta.t_plata, 10, space + 7);
			} else if (oferta.valid) {
				doc.text(
					"Valabilitate oferta: " + daysTxt,
					10,
					space + 7
				);
			}
		} else {
			if (oferta.t_plata && oferta.valid) {
				doc.text("Conditii plata: " + oferta.t_plata, 10, space + 2);
				doc.text(
					"Valabilitate oferta: " + daysTxt,
					10,
					space + 7
				);
			} else if (oferta.t_plata) {
				doc.text("Conditii plata: " + oferta.t_plata, 10, space + 2);
			} else if (oferta.valid) {
				doc.text(
					"Valabilitate oferta: " + daysTxt,
					10,
					space + 2
				);
			}
		}

		space = space + 23;

		if (oferta.obs && oferta.moneda == "eur") {
			let obs_pdf = oferta.obs;
			let obsSplit = doc.splitTextToSize("Observatii: " + obs_pdf, 190);
			doc.setFont("Roboto", "bold");
			doc.text(obsSplit, 10, space);
			space = space + 5;
			if (obs_pdf.length > 244) {
				space = space + 10;
			} else if (obs_pdf.length > 118) {
				space = space + 5;
			}

			doc.setFont("Roboto", "normal");
			let currencyText =
				"* Valoarea finala a facturii va fi calculata in lei la cursul de schimb al Bancii Transilvania din data facturarii.";
			doc.setFontSize(8);
			doc.text(currencyText, 10, space);
			doc.setFontSize(9);
		} else if (oferta.obs && oferta.moneda != "eur") {
			let obs_pdf = oferta.obs;
			let obsSplit = doc.splitTextToSize("Observatii: " + obs_pdf, 190);
			doc.setFont("Roboto", "bold");
			doc.text(obsSplit, 10, space);
		} else if (oferta.moneda == "eur") {
			doc.setFont("Roboto", "normal");
			let currencyText =
				"* Valoarea finala a facturii va fi calculata in lei la cursul de schimb al Bancii Transilvania din data facturarii.";
			doc.setFontSize(8);
			doc.text(currencyText, 10, space);
			doc.setFontSize(9);
		}

		space = space + 12;

		doc.setDrawColor(150);
		doc.setLineWidth(0.3);
		doc.setLineDash([1, 1], 0);
		doc.line(10, space, 200, space);

		doc.setLineDash([], 0);
		doc.setFontSize(10);
		doc.setFont("Roboto", "normal");
		doc.text("Oferim urmatoarele servicii:", 10, space + 7);
		doc.setFont("Roboto", "bold");
		doc.setFontSize(9);
		doc.text("DEBITARE:", 10, space + 15);
		doc.setFontSize(9);
		doc.text("Pentru tabla dreapta sau cu striatii:", 10, space + 20);
		doc.setFont("Roboto", "normal");
		doc.text("- aluminiu: pana la grosimea de 8 mm", 10, space + 24);
		doc.text("Lungime Ghilotina: 3000 mm", 10, space + 28);

		doc.setFont("Roboto", "bold");
		doc.text("Pentru profile:", 10, space + 36);
		doc.setFont("Roboto", "normal");
		doc.text("- aluminiu", 10, space + 40);
		doc.text("- debitare dreapta sau in unghi", 10, space + 44);

		space = space + 40;

		if (space > 217) {
			doc.setFont("Roboto", "normal");
			doc.text("Continuare pe pagina urmatoare", 8, space + 10);
			doc.addPage();
			// doc.addImage(imgSide, 'JPEG', 170, 10, 40, 160)
			// doc.text("Print image - 2", 30, 294)
			space = 10;
		}

		space = space + 10;

		// Document footer
		doc.setFont("Roboto", "bold");
		doc.setFontSize(10);
		doc.setTextColor(100);
		doc.setLineWidth(0.3);
		doc.setLineDash([1, 1], 0);
		doc.line(10, space, 200, space);

		doc.setLineDash([], 0);
		doc.addImage(images.data.gard, "JPEG", 100, space + 10, 100, 31);
		space = space + 7;
		doc.text("GARDURI SI PORTI DIN ALUMINIU", 10, space + 10);
		doc.setFontSize(9);
		doc.setFont("Roboto", "normal");
		doc.text("CONFIGURATOR ONLINE", 10, space + 15);

		doc.text("--> https://garduri-aluminiu.ro", 10, space + 22);
		doc.text("--> https://configurator-gard.cuprolli.ro", 10, space + 27);
		space = space + 24;
		

        // Return document
        resolve(doc)
    }
      catch(err) {
        console.error(err)
        router.push({
          query: M.toast({
            html: "Eroare la generare pdf!",
            classes: "red",
          }),
        });
      }
    });
  }
};